var Ribbon = Ribbon || {};
exports.FSRibbon = Ribbon

/** @type String Selector for tabs holder. */
Ribbon.tabsHolder = '.tabs-holder li';

/** @type String Selector for groups holder. */
Ribbon.groupsHolder = '.groups-holder';

/** @type String Selector for groups toggle button. */
Ribbon.toggleBtn = '#toggleBtn';

/** @type String Key to session storage */
Ribbon.buttonDropDownOpenKey = 'buttonDropDown';

/** @type String Slector for components 'drop down' */
Ribbon.dropDown = '.ribbon-buttonDropDown';

/**
 * @returns void
 */
exports.init = function ()
{
    if (!$('.ribbon').length) return;

	//add event on the newly-active just-shown tab
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		if ($(Ribbon.groupsHolder).is(':hidden'))
		{
			Ribbon.toggleGroupsHolder();
		}
	});

	//add event on click tabs
	$(Ribbon.tabsHolder).on('click', function () {
		if ($(this).hasClass('active'))
		{
			Ribbon.toggleGroupsHolder();
		}
	});

	//add event on click toggle button
	$(Ribbon.toggleBtn).on('click', function () {
		Ribbon.toggleGroupsHolder();
	});

	//add event on DropDown shown
	$(Ribbon.dropDown).on('shown.bs.dropdown', function (e) {
		sessionStorage.setItem(Ribbon.buttonDropDownOpenKey, true);
	});

	//add event on DropDown hide
	$(Ribbon.dropDown).on('hide.bs.dropdown', function (e) {
		sessionStorage.setItem(Ribbon.buttonDropDownOpenKey, false);
	});

	//add event on DropDown hover
	$(Ribbon.dropDown).hover(function (e) {
		if (sessionStorage.getItem(Ribbon.buttonDropDownOpenKey) === 'true')
		{
			$('.ribbon-buttonDropDown').removeClass('open');
			$(this).addClass('open');
		}
	});

    //apply ribbon state
    var ribbon_state = JSON.parse(window.localStorage.getItem('ribbon_state')) || new Object();
    if (typeof ribbon_state['visibility'] != 'undefined' && ribbon_state['visibility'] == false){
        $(Ribbon.groupsHolder).hide();
        $(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-up');
        $(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-down');
        $('body').css('padding-top', '57px');
    }

    $(document).on('shown.bs.tab', '.ribbon .tabs-holder a[href]', function(){
        window.sessionStorage.removeItem('ribbon-group-holder-status');
        Ribbon.updateGroupsHolder();
    });

    $(window).resize(function(){
        Ribbon.updateTabsHolder();
        Ribbon.updateGroupsHolder();
    });

    $(document).ready(function(){
        Ribbon.updateTabsHolder();
        Ribbon.updateGroupsHolder();
    });

    $(document).on('click','.tabLeftButton',function(event)
    {
        event.preventDefault();
        Ribbon.updateTabsHolder(-1);
    });

    $(document).on('click','.tabRightButton',function(event)
    {
        event.preventDefault();
        Ribbon.updateTabsHolder(1);
    });

    $(document).on('click','.groupLeftButton',function(event)
    {
        event.preventDefault();
        Ribbon.updateGroupsHolder(-1);
    });

    $(document).on('click','.groupRightButton',function(event)
    {
        event.preventDefault();
        Ribbon.updateGroupsHolder(1);
    });

    $(document).on('click mouseenter', '.ribbon .dropdown-toggle', function()
    {
        $(this).next().toggleClass('dropdown-menu-right', $(document).width() - $(this).offset().left - $(this).next().width() < 0);
    });

    //#42958 - Na iOS se musí kliknout dvakrát na tlačítko v ribbon menu
    $(document).on('touchstart', '.ribbon-buttonDropDown .dropdown-toggle', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($(this).next().is(":hidden")){
            $(this).next().toggleClass('dropdown-menu-right', $(document).width() - $(this).offset().left - $(this).next().width() < 0);
            $(this).dropdown('toggle');
        }
    });
    $(document).on('touchstart', function(event){
        if ($(event.target).closest('.ribbon-buttonDropDown').length == 0){
            $('.ribbon-buttonDropDown.open > a').dropdown('toggle');
        }
    });

    $(document).on('click','a[data-ribbonajax]', function(event)
    {
        event.preventDefault();

        var modalWindow = $(this).data('ribbonmodal');
        var linkVar = $(this).data('ribbonajax');
        var cache = $(this).data('ribboncache');

        if (!cache) $(modalWindow).empty();

        //is modal already loaded?
        if($(modalWindow).children().length == 0 )
        {
            waiter_open('large');
            try {
                $(modalWindow).load(linkVar, function ( response, status, xhr )
                {
                    FSForms.init();
                    waiter_close();
                });
            }
            catch(err) {
                alert(err.message);
                waiter_close();
            }
        }
    });

    $('#header_settings_toggler, #header_help_info_button').on('click', function (event) {
        event.preventDefault();
        $('.ribbon .tabs-holder a[href="' + $(this).attr('href') + '"]').trigger('click');
    });
};

/**
 * @returns void
 */
Ribbon.toggleGroupsHolder = function ()
{
	$(Ribbon.groupsHolder).toggle();
    var ribbon_state = JSON.parse(window.localStorage.getItem('ribbon_state')) || new Object();

	//toggle icon
	if ($(Ribbon.toggleBtn + ' span').hasClass('glyphicon-menu-up'))
	{
		$(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-up');
		$(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-down');

        ribbon_state['visibility'] = false;
    	$('body').css('padding-top', '57px');
	}
	else
	{
		$(Ribbon.toggleBtn + ' span').removeClass('glyphicon-menu-down');
		$(Ribbon.toggleBtn + ' span').addClass('glyphicon-menu-up');

        ribbon_state['visibility'] = true;
		$('body').css('padding-top', '133px');
	}

    window.localStorage.setItem('ribbon_state', JSON.stringify(ribbon_state));
};

Ribbon.updateScrolling = function(def)
{
    if (def.totalWidth > def.bodyWidth && !isLayoutMobile()){
        if (!$(def.cover+' .'+def.type+'MoveButton').length){
            $(def.cover).prepend('<a href="#" class="'+def.type+'MoveButton '+def.type+'RightButton"><span class="glyphicon glyphicon-menu-right"></span></a>');
            $(def.cover).prepend('<a href="#" class="'+def.type+'MoveButton '+def.type+'LeftButton"><span class="glyphicon glyphicon-menu-left"></span></a>');
        }
        var movinButtonWidth = $(def.cover + ' .'+def.type+'RightButton').outerWidth();
        var maxPosition = -(def.totalWidth-def.bodyWidth+movinButtonWidth);
        var actualPosition = JSON.parse(window.sessionStorage.getItem('ribbon-'+def.type+'-holder-position')) || 0;
        if (typeof def.move !== 'undefined') actualPosition -= (def.bodyWidth - movinButtonWidth * 2) * def.move;
        actualPosition = Math.min(Math.max(actualPosition, maxPosition), 0);
        window.sessionStorage.setItem('ribbon-'+def.type+'-holder-position', actualPosition);
        $(def.cover + ' .'+def.type+'LeftButton').toggle(actualPosition != 0);
        $(def.cover + ' .'+def.type+'RightButton').toggle(actualPosition != maxPosition);
        if (typeof def.move === 'undefined'){
            $(def.cover+' '+def.content).css({ left: actualPosition+'px' });
        }else{
            $(def.cover+' '+def.content).animate({ left: actualPosition+'px' }, 500);
        }
    }else{
        $(def.cover+' '+def.content).css({left: 0});
        $(def.cover+' .'+def.type+'MoveButton').remove();
    }
};

Ribbon.updateTabsHolder = function (move){
    Ribbon.updateScrolling({
        totalWidth: $($('.tabs-holder')[0]).width(),
        bodyWidth: $('#tabs-holder-cover').width(),
        cover: '#tabs-holder-cover',
        content: '.tabs-holder',
        type: 'tab',
        move: move
    });
};

Ribbon.updateGroupsHolder = function (move){
    Ribbon.updateScrolling({
        totalWidth: function(){ var totalWidth = 30; $('.groups-holder .active .ribbon-group').each(function(){ totalWidth += $(this).outerWidth(); }); return totalWidth; }(),
        bodyWidth: $('body').width(),
        cover: '.groups-holder',
        content: '.active',
        type: 'group',
        move: move
    });
};


// WEBPACK FOOTER //
// ./client-side/Ribbon/js/ribbon.js